module.exports = __webpack_public_path__ + "static/media/cambridge_home.1ef94f6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/cambridge_home.png
// module id = 517
// module chunks = 0